<template src="../public/theme/base/mainpage.html"></template>

<script>
import ProfileView from '@/components/ProfileComponent'
import BiographyComponent from '@/components/BiographyComponent'
import EducationComponent from '@/components/EducationComponent'
import EmploymentComponent from '@/components/EmploymentComponent'
import HonorsComponent from '@/components/HonorsComponent'
import SkillsComponent from '@/components/SkillsComponent'
import PortfolioComponent from '@/components/PortfolioComponent'
import FooterComponent from '@/components/FooterComponent'
import LanguagesComponent from '@/components/LanguagesComponent'

export default {
  name: 'top-page',
  components: {
    ProfileView,
    BiographyComponent,
    EducationComponent,
    EmploymentComponent,
    HonorsComponent,
    SkillsComponent,
    PortfolioComponent,
    LanguagesComponent,
    FooterComponent,
  },
  created() {
    this.$store.dispatch('loadCV')
  },
  data() {
    return {
      menuVisible: false,
    }
  },
  methods: {
    displaySection(title) {
      return this.$store.getters.displaySection(title)
    },
  },
}
</script>

<style lang="scss">
// Import global custom sass
@import 'sass/main';
</style>
